module.exports = __webpack_public_path__ + "static/img/ban03.e4e621f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/ban03.jpg
// module id = gZjy
// module chunks = 1